import UserProfileLayout from "./UserProfileLayout";

export default UserProfileLayout;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/users/UserProfileLayout/index.tsx